import React, { Component } from 'react';
import { Route as Match } from 'react-router-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { loadBuilding, loadPavilions, loadChess } from 'actions/building';

import debounce from 'lodash.debounce';

import { parseQuery } from 'utils';

import BuildingComponent from 'components/Building';
import BuildingTitle from 'components/Header/BuildingTitle';
import About from 'components/Building/Chess/RightMenu/About/About';
import Gallery from 'components/Building/Chess/RightMenu/Gallery/Gallery';
import withValidTrafic from 'decorators/withValidTrafic';

const PAGE_SIZE = 20;

@withValidTrafic()
class Building extends Component {

  constructor() {
    super();
    this.state = {
      hasBeenPrinted: false,
      chessLoaded: false
    };
    this.print = debounce(this.print, 2000);
  }

  UNSAFE_componentWillMount() {
    const { loadBuilding, loadPavilions, loadChess, match: { params } } = this.props;
    loadBuilding(params.id).then(resp => {
      resp.data.data.pavilions.map(
        (pavilion) => {
          const sectionReqs = pavilion.sectionIds
          // .filter(sectionId => query[`chess${sectionId}`] === 'true')
          .map(sectionId => loadChess({ id: sectionId }));
          return Promise.all(sectionReqs);
        }
      );
    });
    loadPavilions(params.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.sections && nextProps.building.pavilions) {
      this.sections = nextProps.building.pavilions.reduce(
        (sections, pavilion) => (
          {
            ...sections,
            ...(pavilion.sections.reduce(
              (sections, section) => (
                {
                  ...sections,
                  [section.id]: { ...section, pavilionName: pavilion.name }
                }
              ), {}
            ))
          }
        ), {}
      );
    }
    if (this.sections && Object.keys(this.sections).every(sectionId => nextProps.building.chessList[sectionId])) {
      const plans = {};
      const query = parseQuery(location.search);
      Object.keys(nextProps.building.chessList).forEach(
        (sectionId) => (
          nextProps.building.chessList[sectionId].cells.forEach(
            ({ planId, row }) => {
              if (planId && query[`plans${planId}`] === 'true') {
                plans[planId] = { ...(plans[planId] || {}), row, sectionId };
              }
            }
          )
        )
      );
      this.setState({
        didReceiveSections: true,
        plans
      });
    }
    if (
      !this.state.hasBeenPrinted &&
      // this.state.chessLoaded &&
      !nextProps.building.isPavilionsLoading &&
      !nextProps.building.isChessLoading &&
      !nextProps.building.isLoading &&
      nextProps.building.pavilions &&
      nextProps.building.chessList &&
      nextProps.building.data
    ) {
      const query = parseQuery(location.search);
      if (
        (
          !query.roomPlan &&
          Object.keys(query)
          .filter(key => key.includes('plans') && query[key] === 'true')
          .length === 0
        ) && (
          Object.keys(query)
          .filter(key => key.includes('chess') && query[key] === 'true')
          .length <= Object.keys(nextProps.building.chessList).length
        )
      ) {
        setTimeout(this.print, 1000);
        this.setState({ hasBeenPrinted: true });
      }
    }
  }

  handleImageLoad = () => {
    if (!this.imageCounter) {
      this.imageCounter = 0;
    }
    this.imageCounter += 1;
    if (Object.keys(this.state.plans).length === this.imageCounter) {
      this.print();
    }
  }

  print = () => {
    setTimeout(window.print, 3000);
    this.setState({ hasBeenPrinted: true });
  }

  render() {
    const { dispatch, building, match, match: { params }, location, search } = this.props;
    const query = parseQuery(location.search);
    return (
      <Match
        render={(matchProps) => (
          <div>
            <Match
              render={() => <BuildingComponent.Main {...matchProps} dispatch={dispatch} params={params} building={building} print={query} />}
            />
            {
            building.data && building.data.pavilions
            .map(
              pavilion => (
                <div key={pavilion.id}>
                  {
                    pavilion.sectionIds
                    .filter(sectionId => query[`chess${sectionId}`] === 'true')
                    .map(
                      (sectionId, sectionIndex) => (
                        building.chessList[sectionId] ?
                        Array(Math.ceil(building.chessList[sectionId].cols.length / PAGE_SIZE))
                        .fill(0)
                        .map((_, page) => (
                          <BuildingComponent.Chess
                            {...matchProps}
                            dispatch={dispatch}
                            match={match}
                            key={page}
                            page={page}
                            pageSize={PAGE_SIZE}
                            search={search}
                            building={{
                              ...building,
                              filters: {
                                section: [building.data.pavilions.indexOf(pavilion), sectionIndex]
                              },
                              isExtended: true
                            }}
                            print
                          />
                        )) : null
                      )
                    )

                  }
                </div>
              )
            )
          }
            {
            this.state.plans &&
            Object.keys(this.state.plans)
            .map(
              planId => {
                const plan = this.state.plans[planId];
                return (
                  <Gallery
                    building={building}
                    data={{
                      planId,
                      data: { floorName: plan.row + 1 }
                    }}
                    print
                    sectionName={this.sections[plan.sectionId].name}
                    pavilionName={this.sections[plan.sectionId].pavilionName}
                    handleImageLoad={this.handleImageLoad}
                    handleImageError={this.handleImageLoad}
                  />
                );
              }
            )
          }
            {
            query.roomPlan && building.chessList[query.sectionId] &&
            <div>
              <BuildingTitle
                building={building}
                print
              />
              <About
                building={building}
                data={building.chessList[query.sectionId].cells.filter(room => room.id === query.roomPlan)[0]}
                handleImageLoad={this.print}
                handleImageError={this.print}
                print
              />
            </div>
          }
          </div>
      )}
      />
    );
  }
}

const buildingSelector = createSelector(
  state => state.building,
  state => state.search,
  (building, search) => ({ building, search })
);

export default connect(buildingSelector, { loadBuilding, loadPavilions, loadChess })(Building);



// WEBPACK FOOTER //
// ./src/containers/PrintBuilding/PrintBuilding.js